import { render, staticRenderFns } from "./vuetifyTable.vue?vue&type=template&id=53796988&"
import script from "./vuetifyTable.vue?vue&type=script&lang=js&"
export * from "./vuetifyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports